import { formatNumber } from "../../utils/eventFormatters";

const formatMetricName = (metricName) => {
  const name = String(metricName).split("/").pop() || metricName;

  return name
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const normalizeStoreRows = (metrics) =>
  Object.entries(metrics || {})
    .filter(([, value]) => value !== null && typeof value !== "object")
    .map(([metricName, value], index) => ({
      id: metricName,
      position: index + 1,
      item: formatMetricName(metricName),
      redemptions: formatNumber(value),
    }));

const getEventYear = (event) => {
  const [, , year] = String(event?.startDate || "").split("/");

  return year;
};

export const getStoreModalTitle = (event) => {
  if (!event?.name) {
    return "EVENTO DE LOJINHA";
  }

  const eventName = event.name
    .replace(/\s*Lojinha\s*/gi, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
  const hasYearInName = /\b\d{4}\b/.test(eventName);
  const year = hasYearInName ? "" : getEventYear(event);

  return `EVENTO DE ${[eventName, year].filter(Boolean).join(" ").toUpperCase()}`;
};
